export default [
    {
        path: '/languages',
        name: 'languages',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Languages.vue')
    }
]